export const GET_CHART_LIST_START = "GET_CHART_LIST_START";
export const GET_CHART_LIST_SUCCESS = "GET_CHART_LIST_SUCCESS";
export const GET_CHART_LIST_FAILURE = "GET_CHART_LIST_FAILURE";
